import { FinanceCircular } from '../types/catalog';
import { fiatCircular } from './fiatCircular';
import { jeepCircular, ramCircular } from './jeepRamCircular';
import { citroenCircular } from './citroenCircular';

/** Circulares oficiales vigentes, una por marca. Al vencer, la marca vuelve a sus condiciones generales. */
export const financeCirculars: FinanceCircular[] = [fiatCircular, jeepCircular, ramCircular, citroenCircular];
